const ALL_PRODUCTS = "all-products";

export const oldStoreBasePathWithoutCountryCode = "/stores/:storeCode/:storeNumber";

export const oldCreateStoreBasePathWithoutCountryCode = "/stores/create/:storeCode/:storeNumber";
export const oldStoreAccessDenied = "/stores/:storeCode/:storeNumber/access-denied";

export const oldStoreBasePath = "/:countryCode/:lang/stores/:storeCode/:storeNumber";
export const oldCreateStoreBasePath = "/:countryCode/:lang/stores/create/:storeCode/:storeNumber";
export const oldStoreDeactivatedPath = "/stores/:storeCode/:storeNumber/deactivated-message";

export const OLD_ORDER_REDEMPTION_PAGE_PATHNAME = "/[countryCode]/[lang]/orders/[inviteToken]";

export const OLD_ORDER_REDEMPTION_PAGE_PATHNAME_WITH_WORKSPACE =
  "/[countryCode]/[lang]/orders/[slug]/[inviteToken]";

export const OLD_STORE_HOME_PAGE_PATHNAME = "/[countryCode]/[lang]/stores/[slug]/[storeNumber]";

export const OLD_STORE_INVITE_PAGE_PATHNAME =
  "/[countryCode]/[lang]/stores/[slug]/[storeNumber]/invite/[token]";

export const OLD_STORE_MENU_PAGE_PATHNAME =
  "/[countryCode]/[lang]/stores/[slug]/[storeNumber]/menu";

export const OLD_STORE_CREATE_PAGE_PATHNAME =
  "/[countryCode]/[lang]/stores/create/[slug]/[storeNumber]";

export const OLD_STORE_BRAND_PAGE_PATHNAME =
  "/[countryCode]/[lang]/stores/[slug]/[storeNumber]/brand/[brandSlug]";

export const OLD_STORE_COLLECTION_PAGE_PATHNAME =
  "/[countryCode]/[lang]/stores/[slug]/[storeNumber]/collection/[menuIdentifier]";

export const OLD_MENU_ITEM_ROUTE =
  "/[countryCode]/[lang]/stores/[slug]/[storeNumber]/menu/[menuItem]";

export const OLD_BASE_DEACTIVATED_PAGE = "/stores/[slug]/[storeNumber]/deactivated-message";

export const OLD_BASE_STORE_ACCESS_DENIED_PAGE = "/stores/[slug]/[storeNumber]/access-denied";

export const OLD_STORE_ACCESS_DENIED_PAGE = `/[countryCode]/[lang]${OLD_BASE_STORE_ACCESS_DENIED_PAGE}`;

export const OLD_STORE_DEACTIVATED_PAGE = `/[countryCode]/[lang]${OLD_BASE_DEACTIVATED_PAGE}`;

export const OLD_STORE_ORDER_CONFIRMATION_ROUTE = `${OLD_STORE_HOME_PAGE_PATHNAME}/orders/[orderNumber]/confirmation`;

export const OLD_SEARCH_PAGE_PATHNAME = `${OLD_STORE_HOME_PAGE_PATHNAME}/search`;

export const OLD_SEARCH_QUERY_PAGE_PATHNAME = `${OLD_STORE_HOME_PAGE_PATHNAME}/search/[searchQuery]`;

export const OLD_MENU_PAGE_PATHNAME_WITH_SUBCATEGORY = `${OLD_STORE_HOME_PAGE_PATHNAME}/[category]/[subCategory]`;

export const OLD_MENU_PAGE_PATHNAME = `${OLD_STORE_HOME_PAGE_PATHNAME}/[category]`;

export const OLD_PRODUCT_VIEW_PATHNAME = `${OLD_STORE_HOME_PAGE_PATHNAME}/p/[productSlug]`;

export const OLD_CART_PAGE_PATHNAME = `${OLD_STORE_HOME_PAGE_PATHNAME}/cart`;

export const OLD_ALL_PRODUCTS_PATHNAME = `${OLD_STORE_HOME_PAGE_PATHNAME}/${ALL_PRODUCTS}/all`;

export const OLD_CHECKOUT_PAGE_PATHNAME = `${OLD_STORE_HOME_PAGE_PATHNAME}/orders/[orderNumber]/checkout`;

export const OLD_ORDER_CONFIRMATION_PAGE_PATHNAME = `${OLD_STORE_HOME_PAGE_PATHNAME}/orders/[orderNumber]/confirmation`;
